var map = {
	"./logo_Anaseguros.svg": "7baa",
	"./logo_Atlas.svg": "57f4",
	"./logo_Axa.svg": "499c",
	"./logo_Chubb.svg": "ded4",
	"./logo_Generalseguros.svg": "a909",
	"./logo_Gnp.svg": "a23f",
	"./logo_Hdi.svg": "05a7",
	"./logo_Primeroseguros.svg": "81cf",
	"./logo_Qualitas.svg": "e8c4",
	"./logo_Zurich.svg": "15d8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a6fa";